import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectIsNotLoggedIn } from '../+state/auth.reducer';

export const notLoginGuard = async () => {
    const router = inject(Router);
    const store = inject(Store);
    const isNotLoggedIn = store.selectSignal(selectIsNotLoggedIn)();
    if (!isNotLoggedIn) {
        await router.navigateByUrl('/');
    }
    return isNotLoggedIn;
};
